import { getSignInDestination } from '../../utils/session';
import React, { Component } from 'react';
import api, { API_ENDPOINTS, clearGuestCartId, getGuestCartId, getOtpCooldown, getOtpErrorMessage, isOtpRequestEnded } from '../../api/Api';
import {NotificationManager} from 'react-notifications';
import {login} from '../../utils/index'
import store, {CART_COUNT_UPDATE} from '../../utils/store';

class Signinotp extends Component {

    constructor(props) {
        super(props);
        this.state = {
            step:'mobile',
            mobile_number:'',
            otpDigits:['', '', '', '', '', ''],
            otpRequestId:'',
            otpDestination:'',
            resendCountdown:0,
            isSendingOtp:false,
            isVerifyingOtp:false,
            serviceCheck:false,
        };
        this.otpInputRefs = [];
        this.resendTimer = null;
    }

    componentDidMount() {
        this.clearResendTimer();
    }

    componentWillUnmount() {
        this.clearResendTimer();
    }

    clearResendTimer() {
        if (this.resendTimer) {
            clearInterval(this.resendTimer);
            this.resendTimer = null;
        }
    }

    startResendTimer(duration = 0) {
        this.clearResendTimer();
        this.setState({resendCountdown: duration});
        if (!duration) return;
        this.resendTimer = setInterval(() => {
            this.setState((prevState) => {
                if (prevState.resendCountdown <= 1) {
                    this.clearResendTimer();
                    return {resendCountdown: 0};
                }
                return {resendCountdown: prevState.resendCountdown - 1};
            });
        }, 1000);
    }

    isValidMobileNumber() {
        return /^\d{10}$/.test(this.state.mobile_number);
    }

    getOtpValue() {
        return this.state.otpDigits.join('');
    }

    maskMobileNumber(number) {
        if (!number || number.length < 4) {
            return 'your mobile number';
        }

        return `••••••${number.slice(-4)}`;
    }

    formatCountdown(seconds) {
        const safeSeconds = Math.max(0, seconds);
        const minutes = String(Math.floor(safeSeconds / 60)).padStart(2, '0');
        const remainingSeconds = String(safeSeconds % 60).padStart(2, '0');
        return `${minutes}:${remainingSeconds}`;
    }

    isOtpComplete() {
        return /^\d{6}$/.test(this.getOtpValue());
    }

    focusOtpIndex(index) {
        if (this.otpInputRefs[index]) {
            this.otpInputRefs[index].focus();
        }
    }

    async handlePrimaryAction() {
        if (this.state.step === 'mobile') {
            await this.getOTP();
        } else {
            await this.submitsigninotp();
        }
    }

    async submitsigninotp(){
        if (this.state.isSendingOtp || this.state.isVerifyingOtp || !this.state.otpRequestId) return;
        const mobile_otp = this.getOtpValue();

        if(!this.isValidMobileNumber()) {
            NotificationManager.error('Please enter the valid mobile number');
        }else if(!this.isOtpComplete()) {
            NotificationManager.error('Please enter the mobile OTP');
        }else{

            try {
                this.setState({isVerifyingOtp:true, otp_error:''});
                const response = await api.post(API_ENDPOINTS.auth.verifyOtp, {
                    request_id: this.state.otpRequestId,
                    otp: mobile_otp,
                    guest_cart_id: getGuestCartId(),
                });
                let resVal=response.data;
                const token = resVal.token || resVal.access_token || (resVal.data && (resVal.data.token || resVal.data.access_token));
                if(token){
                    login(token);
                    clearGuestCartId();
                    store.dispatch({ type:CART_COUNT_UPDATE, value:resVal.cartCount || (resVal.data && resVal.data.cart_count) || 0});
                    localStorage.setItem('natureway_username',resVal.username || (resVal.data && resVal.data.username) || (resVal.data && resVal.data.customer && [resVal.data.customer.first_name, resVal.data.customer.last_name].filter(Boolean).join(' ')) || '');
                    NotificationManager.success(resVal.message || 'Logged in successfully');
                    window.scrollTo(0, 0);
                    this.props.history.replace(getSignInDestination(this.props.location));
                }else{
                    NotificationManager.error(resVal.message || 'Invalid or expired OTP');
                }
            } catch (error) {
                this.handleOtpError(error);
            } finally {
                this.setState({isVerifyingOtp:false});
            }

        }
    }


    handleOtpError(error) {
        if (isOtpRequestEnded(error)) {
            this.clearResendTimer();
            this.setState({step:'mobile', otpRequestId:'', otpDigits:['', '', '', '', '', ''], resendCountdown:0});
        }
        if (error.response?.status === 429) this.startResendTimer(getOtpCooldown(error.response));
        const message = getOtpErrorMessage(error);
        this.setState({otp_error:message});
        NotificationManager.error(message);
    }

    async getOTP(resend = false){
        if (this.state.isSendingOtp || this.state.isVerifyingOtp || this.state.resendCountdown > 0) return;
        const { mobile_number }  = this.state ;
        if(this.isValidMobileNumber()){
            try {
                this.setState({isSendingOtp:true, otp_error:''});
                const response = await api.post(resend ? API_ENDPOINTS.auth.resendOtp : API_ENDPOINTS.auth.requestOtp,
                    resend ? { request_id: this.state.otpRequestId } : { mobile: mobile_number });
                let resVal=response.data;
                const requestId = resVal.request_id || (resVal.data && resVal.data.request_id);
                if(response.status === 200 && requestId){
                    NotificationManager.success(resVal.message || 'OTP sent successfully');
                    this.setState({
                        step:'otp',
                        otpDigits:['', '', '', '', '', ''],
                        otpRequestId: requestId,
                        otpDestination: resVal.data?.destination || resVal.destination || '',
                    }, () => {
                        this.startResendTimer(getOtpCooldown(response));
                        this.focusOtpIndex(0);
                    });
                }else{
                    NotificationManager.error(resVal.message || 'Unable to send OTP');
                }
            } catch (error) {
                this.handleOtpError(error);
            } finally {
                this.setState({isSendingOtp:false});
            }

        }else{
            NotificationManager.error('Invalid mobile number');
        }
    }


    async resendOTP(){
        if(this.state.resendCountdown > 0) {
            return;
        }
        if (!this.state.otpRequestId) return;
        await this.getOTP(true);
    }

    handleBack = () => {
        if (this.state.isSendingOtp || this.state.isVerifyingOtp) return;
        this.clearResendTimer();
        this.setState({
            step:'mobile',
            otpDigits:['', '', '', '', '', ''],
            resendCountdown:0,
            otpRequestId:'',
            otpDestination:'',
            otp_error:'',
        }, () => {
            this.focusOtpIndex(0);
        });
    }

    handleMobileChange(event) {
        const value = event.target.value.replace(/\D/g, '').slice(0, 10);
        this.setState({mobile_number:value});
    }

    handleOtpChange(index, event) {
        const rawValue = event.target.value.replace(/\D/g, '');
        const value = rawValue.slice(-1);

        this.setState((prevState) => {
            const otpDigits = [...prevState.otpDigits];
            otpDigits[index] = value;
            return {otpDigits};
        }, () => {
            if (value && index < 5) {
                this.focusOtpIndex(index + 1);
            }
        });
    }

    handleOtpKeyDown(index, event) {
        if (event.key === 'Backspace' && !this.state.otpDigits[index] && index > 0) {
            this.focusOtpIndex(index - 1);
        }
        if (event.key === 'ArrowLeft' && index > 0) {
            this.focusOtpIndex(index - 1);
        }
        if (event.key === 'ArrowRight' && index < 5) {
            this.focusOtpIndex(index + 1);
        }
    }

    handleOtpPaste(event) {
        const pastedValue = event.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
        if (!pastedValue) {
            return;
        }
        event.preventDefault();
        const otpDigits = Array.from({length: 6}, (_, index) => pastedValue[index] || '');
        this.setState({otpDigits}, () => {
            const nextIndex = Math.min(pastedValue.length, 5);
            this.focusOtpIndex(nextIndex);
        });
    }

    storeState(elementName,event) {
        if(elementName === 'mobile_number'){
            this.handleMobileChange(event);
        }
    }

    render() {

        const { step, mobile_number, otpDigits, resendCountdown, isSendingOtp, isVerifyingOtp }  = this.state ;
        const primaryDisabled = step === 'mobile'
            ? !this.isValidMobileNumber() || isSendingOtp || resendCountdown > 0
            : !this.isOtpComplete() || isVerifyingOtp || isSendingOtp;
        return (
            <>
                <div className={`auth-otp auth-otp--${step}`}>
                    <div className="auth-otp__stepper">
                        <div className="auth-otp__step-item auth-otp__step-item--active">
                            <span className={`auth-otp__step ${step === 'mobile' || this.isValidMobileNumber() ? 'auth-otp__step--active' : ''}`}>1</span>
                            <div className="auth-otp__step-copy">
                                <strong>Mobile number</strong>
                                <small>Receive a login code</small>
                            </div>
                        </div>
                        <div className="auth-otp__stepper-line" aria-hidden="true">
                            <span className={`auth-otp__stepper-fill ${step === 'otp' ? 'auth-otp__stepper-fill--active' : ''}`} />
                        </div>
                        <div className={`auth-otp__step-item ${step === 'otp' ? 'auth-otp__step-item--active' : ''}`}>
                            <span className={`auth-otp__step ${step === 'otp' ? 'auth-otp__step--active' : ''}`}>2</span>
                            <div className="auth-otp__step-copy">
                                <strong>Verify OTP</strong>
                                <small>Enter the 6 digit code</small>
                            </div>
                        </div>
                    </div>

                    <div className="auth-otp__fields">
                        <div className="auth-otp__field">
                            <div className="auth-otp__field-head">
                                <label className="auth-otp__label" id="signin-otp-label" htmlFor={step === 'mobile' ? 'signin-mobile' : undefined}>{step === 'mobile' ? 'Mobile number' : 'Verify OTP'}</label>
                                {step === 'otp' ? (
                                    <button className="auth-otp__back" type="button" onClick={this.handleBack}>
                                        Back
                                    </button>
                                ) : null}
                            </div>
                            {step === 'mobile' ? (
                                <div className="auth-otp__input-row">
                                    <input
                                        className="auth-otp__input"
                                        id="signin-mobile"
                                        name="mobile_number"
                                        placeholder="Enter your 10 digit number"
                                        maxLength="10"
                                        type="text"
                                        inputMode="numeric"
                                        autoComplete="off"
                                        autoCorrect="off"
                                        autoCapitalize="off"
                                        spellCheck={false}
                                        autoSave="off"
                                        value={mobile_number}
                                        onChange={(event)=>this.storeState('mobile_number',event)}
                                    />
                                </div>
                            ) : (
                                <div className="auth-otp__summaryBox">
                                    <span className="auth-otp__summaryLabel">OTP sent to</span>
                                    <strong className="auth-otp__summaryValue">{this.state.otpDestination || this.maskMobileNumber(mobile_number)}</strong>
                                    <span className="auth-otp__summaryNote">Use the 6 digit code sent to this number.</span>
                                </div>
                            )}
                            <p className="auth-otp__hint">
                                {step === 'mobile'
                                    ? 'We will send a 6-digit code to verify your number.'
                                    : 'Enter the 6 digit code sent to your mobile number.'}
                            </p>
                        </div>

                        {step === 'otp' ? (
                            <div className="auth-otp__field">
                                <div className="auth-otp__code-row" role="group" aria-labelledby="signin-otp-label" onPaste={(event)=>this.handleOtpPaste(event)}>
                                    {otpDigits.map((digit, index) => (
                                        <input
                                            key={index}
                                            ref={(el) => { this.otpInputRefs[index] = el; }}
                                            className="auth-otp__code-box"
                                            type="text"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            maxLength="1"
                                            aria-label={`OTP digit ${index + 1}`}
                                            value={digit}
                                            onChange={(event)=>this.handleOtpChange(index, event)}
                                            onKeyDown={(event)=>this.handleOtpKeyDown(index, event)}
                                        />
                                    ))}
                                </div>
                                <div className="auth-otp__resend-card">
                                    <div className="auth-otp__resend-copy">
                                        <span className="auth-otp__resend-label">Need another code?</span>
                                        <span className="auth-otp__resend-note">
                                            {resendCountdown > 0
                                                ? `Resend available in ${this.formatCountdown(resendCountdown)}`
                                                : 'You can request a new OTP right away.'}
                                        </span>
                                    </div>
                                    <div className="auth-otp__resend-action">
                                        <button
                                            className="auth-otp__resend"
                                            type="button"
                                            onClick={()=>this.resendOTP()}
                                            disabled={resendCountdown > 0 || isSendingOtp || isVerifyingOtp}
                                        >
                                            Resend OTP
                                        </button>
                                        <span className="auth-otp__resend-support">
                                            {resendCountdown > 0
                                                ? 'Please wait for the timer to finish.'
                                                : 'Tap to get a new code.'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ) : null }
                    </div>

                    <div className="auth-otp__submit">
                        {this.state.otp_error && <p role="alert">{this.state.otp_error}</p>}
                        {step === 'mobile' && resendCountdown > 0 && <p>Try again in {this.formatCountdown(resendCountdown)}.</p>}
                        <button
                            className="auth-otp__submit-btn"
                            type="button"
                            onClick={()=>this.handlePrimaryAction()}
                            disabled={primaryDisabled}
                        >
                            {step === 'mobile' ? (isSendingOtp ? 'Sending OTP...' : 'Continue') : (isVerifyingOtp ? 'Verifying...' : 'Continue')}
                        </button>
                        <div className="auth-otp__secure-note">
                            Protected login for your Natureway account.
                        </div>
                    </div>
                </div>

            </>
        );
    }
}

export default Signinotp;
